import { Link } from "react-router-dom";
import SEOHead from "@/components/SEOHead";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex items-center justify-center pt-32 pb-20 px-6"
    >
      <SEOHead
        title="Lost in the world — 404 · Temple of Kulture"
        description="This page doesn't exist in our universe yet. Step back into the Temple — immersive experiences, LEVEL UP, Ubuntu Retreat and more wait inside."
        noIndex
      />
      <div className="text-center max-w-xl">
        <p className="text-[11px] uppercase tracking-[0.35em] text-amber-400 font-bold mb-6">
          Lost in the world
        </p>
        <h1 className="font-display font-black uppercase leading-[0.9] tracking-tighter text-7xl sm:text-8xl">
          4<span className="text-amber-400">0</span>4
        </h1>
        <p className="mt-6 text-zinc-300 text-lg">
          This page doesn't exist in our universe — yet.
        </p>
        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center bg-amber-400 hover:bg-amber-300 text-black px-8 py-5 font-bold uppercase tracking-[0.25em] text-xs transition-colors"
          >
            Return home
          </Link>
          <Link
            to="/whats-on"
            data-testid="not-found-whats-on-link"
            className="inline-flex items-center border border-amber-400/40 hover:border-amber-400 hover:bg-amber-400/5 text-amber-400 px-8 py-5 font-bold uppercase tracking-[0.25em] text-xs transition-colors"
          >
            See what&apos;s on
          </Link>
        </div>
        <div className="mt-12 text-xs text-zinc-500 flex flex-wrap gap-x-5 gap-y-2 justify-center uppercase tracking-[0.25em]">
          <Link to="/level-up-xr" className="hover:text-amber-400">Level Up</Link>
          <Link to="/ubuntu-retreat" className="hover:text-amber-400">Ubuntu Retreat</Link>
          <Link to="/home-education" className="hover:text-amber-400">Home Education</Link>
          <Link to="/policies" className="hover:text-amber-400">Policies</Link>
        </div>
      </div>
    </div>
  );
}
